import type { Theme } from '@mui/material';

import { useState, useEffect } from 'react';

import {
  Box,
  Checkbox,
  FormGroup,
  Typography,
  useMediaQuery,
  FormControlLabel,
} from '@mui/material';

import { AGE_RANGES } from 'src/utils/constants';

import { Scrollbar } from 'src/components/scrollbar';

export const AgesFilter = (props: { filters: any; setFilters: React.Dispatch<any> }) => {
  const { filters, setFilters } = props;
  const downSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  
  const [selectedAges, setSelectedAges] = useState<number[]>(filters.listing?.ageInterval || []);

  useEffect(() => {
    setSelectedAges(filters.listing?.ageInterval || []);
  }, [filters.listing?.ageInterval]);

  const handleChange = (value: number) => {
    const newSelectedAges = selectedAges.includes(value)
      ? selectedAges.filter((age) => age !== value)
      : [...selectedAges, value];
    setSelectedAges(newSelectedAges);
    setFilters((prev: any) => ({
      ...prev,
      listing: {
        ...prev.listing,
        ageInterval: newSelectedAges.length > 0 ? newSelectedAges : null,
      },
    }));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
        Yaş
      </Typography>

      <Scrollbar sx={{ maxHeight: 164 }}>
        <FormGroup>
          {AGE_RANGES.map((range) => (
            <FormControlLabel
              key={range.value}
              control={
                <Checkbox
                  checked={selectedAges.includes(range.value)}
                  onChange={() => handleChange(range.value)}
                  sx={{ py: 0.25 }}
                />
              }
              label={range.label}
            />
          ))}
        </FormGroup>
      </Scrollbar>
    </Box>
  );
};
